// 救助基金相关数据
import { createMemo } from "solid-js";

import { getActivityCfg, getActivityDetails } from "@/stores/activityStore";
import { ActivityTypeEnum } from "@/types/compontent/base/baseEnum.ts";

const activity_id = ActivityTypeEnum.reliefFund3;

export const useFreeRelief = () => {
  const max = () =>
    getActivityCfg(activity_id)?.cfg.reward_cfgs?.reduce((pre, item) => {
      if (item.reward.rand_pay_pro_max > pre) {
        pre = item.reward.rand_pay_pro_max;
      }
      return pre;
    }, Number(0)) || 0;

  const min = () =>
    getActivityCfg(activity_id)?.cfg.reward_cfgs?.reduce(
      (pre, item) => {
        if (item.reward.rand_pay_pro_min < pre) {
          pre = item.reward.rand_pay_pro_min;
        }
        return pre;
      },
      getActivityCfg(activity_id)?.cfg.reward_cfgs?.[0]?.reward
        ?.rand_pay_pro_min || 0,
    ) || 0;
  // 最高奖励上线
  const maxPointLimit = () =>
    getActivityCfg(activity_id)?.cfg.reward_cfgs?.reduce((pre, item) => {
      if (item?.reward_point_up_limit > pre) {
        pre = item?.reward_point_up_limit;
      }
      return pre;
    }, Number(0)) || 0;

  const minPointLimit = () =>
    getActivityCfg(activity_id)?.cfg.reward_cfgs?.reduce((pre, item) => {
      const limit = item?.reward_point_up_limit ?? Infinity;
      return Math.min(pre, limit);
    }, Infinity) || 0;

  const maxPoint = () =>
    (
      ((getActivityDetails(activity_id)?.details?.first_pay_point || 0) /
        10000) *
      (Number(max()) / 10000)
    ).toFixed(2);

  const _minPoint = () =>
    (
      ((getActivityDetails(activity_id)?.details?.first_pay_point || 0) /
        10000) *
      (Number(min()) / 10000)
    ).toFixed(2);

  const maxPointMemo = () =>
    Number(maxPoint()) > Number(maxPointLimit() / 10000)
      ? `${maxPointLimit() / 10000}`
      : maxPoint();

  const minPointMeno = () =>
    Number(_minPoint()) > Number(minPointLimit() / 10000)
      ? `${minPointLimit() / 10000}`
      : _minPoint();

  const receivablePoint = () =>
    (getActivityDetails(activity_id)?.details?.receivable_point || 0) / 10000;

  const point1 = () =>
    (getActivityCfg(activity_id)?.cfg?.loss_point_less_user_point || 0) / 10000;

  return {
    max: createMemo(() => Number(max())),
    min: createMemo(() => Number(min())),
    maxPoint: createMemo(() => Number(maxPointMemo())),
    minPoint: createMemo(() => Number(minPointMeno())),
    receivablePoint: createMemo(() => receivablePoint()),
    point1: createMemo(() => point1()),
  };
};
